import { frLocale as frLocaleBase } from 'ngx-bootstrap/locale';
frLocaleBase.invalidDate = 'Date invalide';

export const frLocale = {...frLocaleBase, invalidDate: 'Date invalide' };
